module.exports = __webpack_public_path__ + "static/media/emailBouncedIcon.d988aa38.svg";